export default __webpack_public_path__ + "modules@2x.65c9c0bf.png";